import React from "react";
import { PatternFormat } from "react-number-format";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  name?: string;
  margin?: string;
  placeholder?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  showIcon?: boolean;
  icon?: string;
  onChange: (e: any) => void;
}

const Zip: React.FC<InputProps> = ({
  label,
  value,
  name,
  margin,
  placeholder,
  hint,
  error,
  required,
  showIcon = false,
  icon = "bi-geo-alt",
  onChange,
  ...rest
}) => {
  return (
    <Field
      label={label || "Zip Code"}
      margin={margin}
      icon={showIcon ? icon : undefined}
      hint={hint}
      error={error}
      required={required}
    >
      <PatternFormat
        format="#####"
        placeholder={placeholder || "12345"}
        name={name}
        value={value}
        onValueChange={(values) => {
          onChange?.({
            target: {
              name: name,
              value: values.value,
            },
          });
        }}
        valueIsNumericString
        className="form-control"
        {...rest}
      />
    </Field>
  );
};

export default Zip;
